import { render, staticRenderFns } from "./PammTab.vue?vue&type=template&id=6de1af01"
import script from "./PammTab.vue?vue&type=script&lang=js"
export * from "./PammTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports